import api from './api';

export const InstitutionsAPI = {
  getAll: (params = {}) => api.get('/institutions', { params }),
  getOne: (id) => api.get(`/institutions/${id}`),
  create: (data) => api.post('/institutions', data),
  update: (id, data) => api.put(`/institutions/${id}`, data),
  delete: (id) => api.delete(`/institutions/${id}`),
  
  // activation endpoints
  verifyInstitution: (id, data) => api.post(`/institutions/${id}/institution_verification`, data),
  activateInstitution: (id, data) => api.post(`/institutions/${id}/institution_activation`, data),
  rejectVerification: (id, data) => api.post(`/institutions/${id}/verification_rejected`, data),
  suspendInstitution: (id, data) => api.post(`/institutions/${id}/suspend`, data),
  rejectActivation: (id, data) => api.post(`/institutions/${id}/activation_rejected`, data),
  reActivateInstitution: (id, data) => api.post(`/institutions/${id}/reactivate`, data),
  remindPayment: (id) => api.get(`institutions/${id}/prompt_payment_reminder`),
  getProfessionalBodies: () => api.get('/professional_bodies'),
};
